/*
The radio slug rule, ported from ps-back/util/radio/slugify.js (which is itself pspanel's
models/modelUtils.php `slugify`). The manager cannot import from ps-back, so this is a
copy: keep the two in step. The Radio form only uses it for the PREVIEW it prefills on
create; the backend is what decides.

1. every run of characters that are not letters or digits becomes "-";
2. leading and trailing "-" are trimmed;
3. transliterate to ASCII (é -> e, ñ -> n, ç -> c, ß -> ss);
4. lowercase;
5. drop anything that is not "-", a letter, a digit or "_";
6. an empty result becomes "n-a".

An episode's slug is `<programSlug>-<slug of its Spanish title>`.

The combining-mark range (U+0300 to U+036F) is built with String.fromCharCode rather than
written as a regex escape, so no tool along the way can turn it into invisible literal
characters. radioSlug.test.js checks it.

CommonJS so radioSlug.test.js runs under plain node, like cmsTabs.js.
*/

const COMBINING_MARKS = new RegExp(`[${String.fromCharCode(0x300)}-${String.fromCharCode(0x36f)}]`, 'g');

const TRANSLIT = {
  ß: 'ss', æ: 'ae', Æ: 'AE', œ: 'oe', Œ: 'OE', ø: 'o', Ø: 'O', đ: 'd', Đ: 'D', ł: 'l', Ł: 'L', þ: 'th', Þ: 'TH', ð: 'd', Ð: 'D',
};
const TRANSLIT_CHARS = new RegExp(`[${Object.keys(TRANSLIT).join('')}]`, 'g');

const slugify = (text) => {
  let out = String(text === null || text === undefined ? '' : text)
    .replace(/[^\p{L}0-9]+/gu, '-')
    .replace(/^-+|-+$/g, '');
  out = out
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .replace(TRANSLIT_CHARS, c => TRANSLIT[c])
    .toLowerCase()
    .replace(/[^-\w]+/g, '');
  return out || 'n-a';
};

const episodeSlug = (programSlug, title) => `${programSlug}-${slugify(title)}`;

// The shape every stored slug must have: what slugify can produce, joined by "-".
const SLUG_PATTERN = /^[a-z0-9_]+(?:-+[a-z0-9_]+)*$/;

/*
The slug the form prefills on create. Programs: slugify(title.es). Episodes:
<program slug>-<slugify(title.es)>, and nothing until a program is chosen, because the
prefix is half of the URL. An empty title gives '' rather than "n-a", so an empty form
does not show a fake slug.
*/
const suggestSlug = (kind, titleEs, parentSlug) => {
  if (!titleEs || !String(titleEs).trim()) return '';
  if (kind === 'episodes') return parentSlug ? episodeSlug(parentSlug, titleEs) : '';
  return slugify(titleEs);
};

module.exports = {
  slugify,
  episodeSlug,
  suggestSlug,
  SLUG_PATTERN,
  COMBINING_MARKS,
};
